import { userService } from "../services";
import config from "../config/config";

export const VendorAction = {
  fetchVendorList,
  saveUser,
  fetchById,
  userActiveInactive,
  updateUser,
  vehicleTypeList,
  addTransaction,
};

async function fetchVendorList(payload) {
  try {
    let data = {
      companyId: payload.companyId,
      name: payload.name,
      companyName: payload.companyName,
      isActive: payload.isActive,
      siteIds: payload.siteIds,
      userId: payload.userId,
      mineId: payload.mineId,
      areaId: payload.areaId,
      nitId: payload.nitId,
      officialName: payload.officialName,
    };

    let apiEndpoint = `${config.baseUrl}${config.apiName.VendorList}?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;
    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateUser(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.UpdateVendor}`;
    let response = await userService.post(apiEndpoint, payload);
    console.log("updateUserresponse", response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUser(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.AddVendor}`;
    // let data = new FormData();

    // data.append('name', payload.name);
    // data.append('employeeCode', payload.employeeCode);
    // data.append('gender', payload.gender);
    // data.append('email', payload.email);
    // data.append('phoneNumber', payload.phoneNumber);
    // data.append('designation', payload.designation);
    // data.append('address', payload.address);
    // data.append('createdBy', payload.createdBy);
    // data.append('company', payload.company);
    // data.append('file', payload.file);

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ActiveVendor}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.VendorById}?id=${payload.userId}&companyId=${payload.companyId}&userId=${payload.user}&nitId=${payload.nitId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleTypeList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleTypeList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function addTransaction(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.addTransaction}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
